import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { SvgVddMapping } from '../../../projects/client';

export namespace HydraulicSchematicActions {
  export const getHydraulicSchematic = createActionGroup({
    source: 'HYDRAULIC SCHEMATIC Get schematic',
    events: {
      attempt: props<{ hydraMatrixCode: string; bundleId: string; isInternalScheme: boolean }>(),
      error: props<{ error: any }>(),
      success: props<{ hydraulicSchematicSvgModel: any }>(),
    },
  });

  export const getHydraulicSchematicMapping = createActionGroup({
    source: 'HYDRAULIC SCHEMATIC Get schematic mapping',
    events: {
      attempt: emptyProps(),
      error: props<{ error: any }>(),
      success: props<{ hydraulicSchematicMapping: SvgVddMapping[] }>(),
    },
  });

  export const triggerReadVddValuesForSvg = createAction(
    '[HYDRAULIC SCHEMATIC] Trigger read vdd values for svg',
    props<{ gatewaySerial: string }>()
  );

  export const clearState = createAction('[HYDRAULIC SCHEMATIC] Clear State');
}
